/* Modale dettagli e candidatura Jotform */
if (!customElements.get('clai-careers')) {
  customElements.define('clai-careers', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-dialog-content]');
      this.heading = this.querySelector('[data-dialog-title]');

      if (!this.dialog || !this.content || !this.heading) return;

      this.controller?.abort();
      this.controller = new AbortController();

      const options = { signal: this.controller.signal };

      document.addEventListener('click', event => {
        const close = event.target.closest(
          'clai-careers [data-close]'
        );

        if (close && this.contains(close)) {
          this.dialog.close();
          return;
        }

        const detail = event.target.closest(
          '[data-careers-detail]'
        );

        if (detail) {
          const template = document.getElementById(
            detail.dataset.careersDetail
          );

          if (!template) return;

          this.opener = detail;
          this.content.replaceChildren(
            template.content.cloneNode(true)
          );

          const detailHeading = this.content.querySelector(
            '[data-detail-heading]'
          );

          this.heading.textContent =
            detailHeading?.textContent || 'Dettaglio posizione';

          detailHeading?.remove();
          this.open();
          return;
        }

        const apply = event.target.closest('a[href]');
        if (!apply) return;

        const targetUrl = new URL(apply.href, location.href);

        if (
          targetUrl.hash !== '#clai-candidatura' ||
          targetUrl.origin !== location.origin ||
          targetUrl.pathname !== location.pathname
        ) {
          return;
        }

        let url;

        try {
          url = new URL(this.dataset.formUrl);

          if (
            url.protocol !== 'https:' ||
            !/(^|\.)jotform\.com$/.test(url.hostname)
          ) {
            return;
          }
        } catch {
          return;
        }

        event.preventDefault();

        if (!this.dialog.open) {
          this.opener = apply;
        }

        const prefill = (key, raw) => {
          url.searchParams.delete(key);

          const values = [
            ...new Set(
              (raw || '')
                .split('|')
                .map(value => value.trim())
                .filter(Boolean)
            )
          ];

          if (values.length) {
            url.searchParams.set(key, values.join(','));
          }
        };

        prefill(
          'preferenzaSvolgimento',
          apply.dataset.prefillLocations
        );

        prefill(
          'areeAziendali',
          apply.dataset.prefillAreas
        );

        const position =
          apply.dataset.position ||
          this.dataset.spontaneous ||
          'Candidatura spontanea';

        if (this.dataset.positionField) {
          url.searchParams.set(
            this.dataset.positionField,
            position
          );
        }

        this.heading.textContent = position;

        const frame = document.createElement('iframe');
        frame.className = 'careers-frame';
        frame.title = `Modulo candidatura: ${position}`;
        frame.src = url.href;

        const fallback = document.createElement('a');
        fallback.href = url.href;
        fallback.target = '_blank';
        fallback.rel = 'noopener';
        fallback.className = 'text-link';
        fallback.textContent =
          'Apri il modulo in una nuova scheda';

        this.content.replaceChildren(fallback, frame);
        this.open();
      }, options);

      this.dialog.addEventListener('close', () => {
        document.body.style.overflow =
          this.previousOverflow ?? '';

        this.content.replaceChildren();

        if (this.opener?.isConnected) {
          this.opener.focus();
        }
      }, options);
    }

    open() {
      if (!this.dialog.open) {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }

      this.dialog.querySelector('[data-close]')?.focus();
    }

    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow =
          this.previousOverflow ?? '';
      }

      this.controller?.abort();
    }
  });
}

if (!customElements.get('clai-job-list')) {
  customElements.define('clai-job-list', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.tabs = [...this.querySelectorAll('[data-careers-tab]')];
      this.panels = [...this.querySelectorAll('[data-careers-panel]')];
      this.rows = [...this.querySelectorAll('.careers-job-row')];
      this.rail = this.querySelector('.careers-jobs-rail');
      this.nav = this.querySelector('[data-careers-pagination]');
      this.pageSize = Number(this.dataset.pageSize) || 5;

      this.pageButtons = [];
      this.status = null;
      this.nav.replaceChildren();

      const pages = Math.ceil(this.rows.length / this.pageSize);
      this.nav.hidden = pages <= 1;

      if (pages > 1) {
        this.status = document.createElement('p');
        this.status.className = 'careers-page-status';
        this.status.setAttribute('role', 'status');
        this.nav.append(this.status);

        for (let page = 1; page <= pages; page++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'button button--regular button--outline';
          button.textContent = page;
          button.setAttribute('aria-label', `Pagina ${page}`);

          button.addEventListener(
            'click',
            () => this.showPage(page, true),
            options
          );

          this.pageButtons.push(button);
          this.nav.append(button);
        }
      }

      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-careers-tab]');
        if (tab) this.selectTab(tab.dataset.careersTab);
      }, options);

      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-careers-tab]');
        if (!tab) return;

        const index = this.tabs.indexOf(tab);
        let next;

        if (event.key === 'ArrowRight') {
          next = (index + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft') {
          next = (index - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        this.selectTab(this.tabs[next].dataset.careersTab);
        this.tabs[next].focus();
      }, options);

      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;

        const panel = event.target.closest('[data-careers-panel]');
        if (panel) this.selectTab(panel.dataset.careersPanel);

        const index = this.rows.findIndex(row =>
          row === event.target || row.contains(event.target)
        );

        if (index >= 0) {
          this.showPage(Math.floor(index / this.pageSize) + 1, false);
        }
      }, options);

      this.selectTab('jobs');
      this.showPage(1, false);
    }

    selectTab(key) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.careersTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.careersPanel !== key;
      });
    }

    showPage(page, focus) {
      const start = (page - 1) * this.pageSize;

      this.rows.forEach((row, index) => {
        row.hidden =
          index < start || index >= start + this.pageSize;
      });

      this.pageButtons.forEach((button, index) => {
        if (index + 1 === page) {
          button.setAttribute('aria-current', 'page');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      if (this.status) {
        const end = Math.min(
          start + this.pageSize,
          this.rows.length
        );

        this.status.textContent =
          `Posizioni ${start + 1}–${end} di ${this.rows.length}`;
      }

      this.rail.scrollLeft = 0;

      if (focus) {
        const heading = this.querySelector('[data-jobs-heading]');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}